// extracted by css-extract-rspack-plugin
export default {"Fallback":"WebGLDither-module__Fallback__A0TXc"};